import { IDeposit } from "../../../types/driver.interface";
import customAxios from "../../customAxios";
import { UPDATE_DRIVER_DEPOSIT } from "../../routes";

const updateDriverDeposit = async (formData: IDeposit) => {
  try {
    return (
      await customAxios.put(UPDATE_DRIVER_DEPOSIT + "/" + formData?.driverId, {
        deposit: formData.price,
      })
    ).data;
  } catch (error: unknown) {
    console.error({ UPDATE_DRIVER_DEPOSIT: error });
    return false;
  }
};

export default updateDriverDeposit;
